import React from "react";
import { capitalize, formatDate } from "../../../Common/CommonFunction";
import { educationLevelsOptions, JOBSEEKER_PROFILE_IMAGE, performanceScaleOptions, schoolMediumsOptions } from "../../../../Constant";
import github from "../../../../assets/images/resumeIcons/github.png";
import linkedin from "../../../../assets/images/resumeIcons/linkedin.png";
import email from "../../../../assets/images/resumeIcons/email.png";
import call from "../../../../assets/images/resumeIcons/call.png";
import location from "../../../../assets/images/resumeIcons/location.png";
import star_blank from "../../../../assets/images/star/star_blank.png"
import star_half from "../../../../assets/images/star/star_half.png"
import star from "../../../../assets/images/star/star.png"
const ResumeTemplate5 = ({ jobseekerData = {} }) => {
  const {
    jobseeker_full_name = "",
    jobseeker_preferred_job_title = "",
    jobseeker_email1 = "",
    jobseeker_phone1 = "",
    country_code1 = "",
    online_detail_result = [],
    work_experience = [],
    education = [],
    it_skills = [],
    resume_headline = "",
    work_sample = [],
    jobseeker_photo = "",
    jobseeker_location = {},
    primary_skill = []
  } = jobseekerData;

  const renderSocialIcon = (socialProfileName) => {
    switch (socialProfileName.toUpperCase()) {
      case "LINKEDIN":
        return <img className="contact-icon" src={linkedin} alt="LinkedIn Icon" />;
      case "GITHUB":
        return <img className="contact-icon" src={github} alt="GitHub Icon" />;
      default:
        return null;
    }
  };

  return (
    <div id="resume5">
      <div className="resume5">

        <header>
          <a href="#" target="_blank"><img

            src="/job/naukrify_poweredby.png"
            // src="https://dev.naukrify.com/job/naukrify_poweredby.png"
            alt="User profile picture"
            className="img-fluid"
          /></a>
        </header>
        <div className="profile-frame">
          <div className="profile-container">
            {jobseeker_photo && (
              <div className="profile-img">
                <img
                  src={jobseeker_photo}
                  alt="Profile Picture"
                />
              </div>
            )}
            {(jobseeker_full_name || jobseeker_preferred_job_title) && (
              <div className="name">
                {jobseeker_full_name && <h1>{jobseeker_full_name}</h1>}
                {jobseeker_preferred_job_title && <p>{jobseeker_preferred_job_title}</p>}
              </div>
            )}
          </div>
        </div>

        <div className="container5">

          <div className="left">

            <div className="left-section contact">
              <h2>CONTACT</h2>
              <table>
                {jobseeker_email1 && (
                  <tr>
                    <td>
                      <img src={email} alt="Email Icon" />
                    </td>
                    <td>
                      <a href={`mailto:${jobseeker_email1}`}>{jobseeker_email1}</a>
                    </td>
                  </tr>
                )}
                {jobseeker_phone1 && (
                  <tr>
                    <td>
                      <img src={call} alt="Phone Icon" />
                    </td>
                    <td>
                      <a href={`tel:${country_code1}${jobseeker_phone1}`}>
                        {country_code1}{jobseeker_phone1}
                      </a>
                    </td>
                  </tr>
                )}
                {jobseeker_location.label && (
                  <tr>
                    <td>
                      <img src={location} alt="Location Icon" />
                    </td>
                    <td>
                      <a href={`tel:${country_code1}${jobseeker_phone1}`}>
                        {`${jobseeker_location.label}`}
                      </a>
                    </td>
                  </tr>
                )}
                {online_detail_result.map((profile, index) => (
                  (profile.social_profile_name.toUpperCase() === "LINKEDIN" ||
                    profile.social_profile_name.toUpperCase() === "GITHUB") && (
                    <tr>
                      <td>
                        {renderSocialIcon(profile.social_profile_name)}
                      </td>
                      <td>
                        <a href={profile.url} target="_blank" rel="noopener noreferrer">
                          {profile.url}
                        </a>
                      </td>
                    </tr>
                  )
                ))}
              </table>
            </div>

            {it_skills.length > 0 && (
              <div className="left-section skill-left">
                <h2>SKILLS</h2>
                <table>
                  {it_skills.slice(0, 15).map((skill, index) => (
                    <tr>

                      <td><span >{capitalize(skill.it_skill.label)}</span></td>
                    </tr>
                  ))}
                </table>

              </div>
            )}

            {primary_skill.length > 0 && (
              <div className="right-section">
                <h2>MAIN SKILLS</h2>
                {/* <div className="skills-list">
                  {primary_skill.map((skill, index) => (
                    <div className="skill" key={index}>
                      <label>{skill.label}</label>
                      <div className="progress-bar">
                        <div className="progress" style={{ width: `${skill.skill_rating * 10}%` }}></div>
                      </div>
                    </div>
                  ))}
                </div> */}
                <div className="star-skill-list">
                  {primary_skill.map((skill, index) => (
                    <div className="star-skill" key={index}>
                      <p>{skill.label}</p>
                      <div className="star-container">
                        {[...Array(5)].map((_, i) => {
                          let starImage;
                          if (i < Math.floor(skill.skill_rating / 2)) {
                            starImage = star; // Full star
                          } else if (i < Math.ceil(skill.skill_rating / 2)) {
                            starImage = star_half; // Half star
                          } else {
                            starImage = star_blank; // Empty star
                          }
                          return (
                            <img
                              key={i}
                              className="image"
                              src={starImage}
                              alt="star"

                            />
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="right">
            {resume_headline && (
              <div className="about">
                <div className="section-title">
                  <h2>ABOUT ME</h2>
                </div>
                <div className="section-title">
                  <p>{resume_headline}</p>
                </div>
              </div>
            )}
            {education.length > 0 && (
              <div className="work-history">
                <div className="section-title">
                  <h2>EDUCATION</h2>
                </div>
                <div className="experience-list">
                  {education.map((edu, index) => (
                    <div className="experience" key={index}>
                      {edu.education_level != "SECONDARY" &&
                        edu.education_level != "SENIOR_SECONDARY" ? (
                        <div>
                          <h4>
                            {edu.jobseeker_degree &&
                              edu.jobseeker_degree.label}{" "}
                            - {edu.jobseeker_specialization} - {" "}
                            {edu.passing_year}
                          </h4>
                          <p>{edu.board}</p>
                          <p>{
                            performanceScaleOptions.find(
                              (option) =>
                                option.value == edu.performance_scale
                            )?.label
                          }{" "}
                            : {edu.performance}</p>
                        </div>
                      ) : (
                        <div>
                          <h4>
                            {
                              educationLevelsOptions.find(
                                (option) =>
                                  option.value == edu.education_level
                              )?.label
                            }{" "}
                            - {edu.passing_year}{" "}
                          </h4>
                          <p>{edu.board} -{" "}
                            {
                              schoolMediumsOptions.find(
                                (option) => option.value == edu.school_medium
                              )?.label
                            }
                          </p>
                          <p>{
                            performanceScaleOptions.find(
                              (option) =>
                                option.value == edu.performance_scale
                            )?.label
                          }{" "}
                            : {edu.performance}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
            {work_experience.length > 0 && (
              <div className="work-history">
                <div className="section-title">
                  <h2>WORK EXPERIENCE</h2>
                </div>
                <div className="experience-list">
                  {work_experience.map((work, index) => (
                    <div className="experience" key={index}>
                      <h4>{`${formatDate(work.started_working_from)} - ${formatDate(work.worked_till)}`}</h4>
                      <p>{`${capitalize(work.designation)} @ ${work.organization.label}`}</p>
                      <p>{capitalize(work.job_description)}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {work_sample.length > 0 && (
              <div className="work-history">
                <div className="section-title">
                  <h2>WORK SAMPLES</h2>
                </div>
                <div className="experience-list">
                  {work_sample.map((work, index) => (
                    <div className="experience" key={index}>
                      <h4>{`${capitalize(work.work_title)} (${formatDate(work.work_start)} - ${formatDate(work.work_end)})`}</h4>
                      <p>
                        <a href={work.work_url}>{work.work_url}</a>
                      </p>
                      <p>{capitalize(work.work_description)}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResumeTemplate5;